import React from "react";
import fscl from "../assets/logo/fscl.jpg";

export default function ComplaintsPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm p-6 sm:p-10  mt-20">
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-6">
            Feedback and Complaint
          </h1>

          <p className="text-gray-700 mb-4">
            We are always looking for ways to improve our service to you. If
            something has gone wrong, we want to know.
          </p>

          <p className="text-gray-700 mb-4">
            Please send an email to{" "}
            <a
              href="mailto:admin@bicare.co.nz"
              className="text-blue-600 hover:text-blue-800 font-medium hover:underline"
            >
              admin@bicare.co.nz
            </a>{" "}
            and tell us what has happened and how we can resolve matters. If you
            have any documents or correspondence that will help us understand
            your complaint, please attach them to your email.
          </p>

          <p className="text-gray-700 mb-3">
            When we receive your complaint, we will:
          </p>

          <ul className="list-disc pl-5 mb-6 space-y-2 text-gray-700">
            <li>acknowledge your complaint within two working days</li>
            <li>gather and evaluate information about your complaint</li>
            <li>respond to you within 20 working days.</li>
          </ul>

          <div className="pt-6 mt-6 border-t border-gray-200">
            <p className="text-gray-700 mb-4">
              If we cannot resolve your complaint to your satisfaction, you can
              contact{" "}
              <span className="font-semibold">
                Financial Services Complaints Limited – A Financial Ombudsman
                Service (FSCL)
              </span>
              . They are an independent, not-for-profit, external dispute
              resolution service approved by the Minister of Consumer Affairs.
            </p>

            <p className="text-gray-700 mb-4">
              FSCL's role is to investigate and fairly resolve complaints. Their
              service is free (it does not cost you anything).
            </p>

            <p className="text-lg font-semibold text-gray-900 mb-3">
              FSCL's contact details are:
            </p>

            <div className="bg-gray-50 rounded-md p-5 space-y-3">
              <div className="flex flex-col sm:flex-row sm:gap-3">
                <span className="font-semibold text-gray-900 sm:min-w-[100px]">
                  Website:
                </span>
                <span className="text-gray-700">
                  <a
                    href="https://fscl.org.nz"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 hover:underline"
                  >
                    fscl.org.nz
                  </a>
                </span>
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-3">
                <span className="font-semibold text-gray-900 sm:min-w-[100px]">
                  Phone:
                </span>
                <span className="text-gray-700">
                  <a
                    href="tel:0800347257"
                    className="text-blue-600 hover:text-blue-800 hover:underline"
                  >
                    0800 347 257
                  </a>
                </span>
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-3">
                <span className="font-semibold text-gray-900 sm:min-w-[100px]">
                  Email:
                </span>
                <span className="text-gray-700">
                  <a
                    href="mailto:complaints@fscl.org.nz"
                    className="text-blue-600 hover:text-blue-800 hover:underline"
                  >
                    complaints@fscl.org.nz
                  </a>
                </span>
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-3">
                <span className="font-semibold text-gray-900 sm:min-w-[100px]">
                  Address:
                </span>
                <span className="text-gray-700">
                  FSCL, PO Box 5967, Wellington 6140
                </span>
              </div>
            </div>
          </div>

          <div className="text-center mt-10 pt-10 border-t-2 border-gray-200">
            <img
              src={fscl}
              alt="FSCL Logo"
              className="inline-block max-w-[300px] h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
